const actionTypes = {
  GET_ANNUAL_SURVEY_REQUEST: 'GET_ANNUAL_SURVEY_REQUEST',
  GET_ANNUAL_SURVEY_RECEIVE: 'GET_ANNUAL_SURVEY_RECEIVE',
  GET_ANNUAL_SURVEY_FAIL: 'GET_ANNUAL_SURVEY_FAIL',
  SET_ANNUAL_SURVEY_LOADING_ACTION: 'SET_ANNUAL_SURVEY_LOADING_ACTION',
};

export default actionTypes;
